module.exports = __webpack_public_path__ + "node_modules/angular-i18n/angular-locale_de.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=[path][name].[ext]&context=.!./~/angular-i18n/angular-locale_de.js
// module id = 401
// module chunks = 0